import React from 'react'
import { authorType } from '../article'

interface authorTagType {
  author: authorType
  occupation?: boolean
  pictureDimension?: string
  userNameClassName?: string
  occupationClassName?: string
  tagClassName?: string
}

export const AuthorTag = ({
  author,
  occupation = true,
  pictureDimension = 'w-6 h-6',
  userNameClassName,
  occupationClassName,
  tagClassName,
}: authorTagType) => (
  <div className='flex'>
    <div className={`flex items-center ${tagClassName} p-1 gap-1 rounded-2xl`}>
      <div className={`${pictureDimension}`}>
        {author.avatar ? (
          <img src={author.avatar} className='rounded-full' />
        ) : (
          <div className='text-center bg-gray-300 rounded-full'>?</div>
        )}
      </div>

      <div className='flex flex-col mr-[6px]'>
        <span className={`${userNameClassName} line-clamp-1 tracking-wide`}>
          {author.name}
        </span>

        <span className={`${occupationClassName} line-clamp-1`}>
          {occupation
            ? author.author_type
            : author.linkedin_url && (
                <a href={author.linkedin_url} className='underline'>
                  View profile
                </a>
              )}
        </span>
      </div>
    </div>
  </div>
)
